import { useState } from 'react';
import { DisciplineWithLessonsInput } from '@/hooks/useConfigExam';

export function useDisciplineModalManager(
  disciplinesWithLessons: DisciplineWithLessonsInput[],
) {
  const [open, setOpen] = useState(false);
  const [openDisciplineWithLesson, setOpenDisciplineWithLesson] =
    useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedGiftId, setSelectedGiftId] = useState<string | null>(null);
  const [editingDiscipline, setEditingDiscipline] = useState<{
    index: number;
    data: DisciplineWithLessonsInput;
  } | null>(null);

  const handleOpenDeleteModal = (id: string) => {
    setSelectedGiftId(id);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedGiftId(null);
  };

  const handleEditDiscipline = (index: number) => {
    setEditingDiscipline({
      index,
      data: disciplinesWithLessons[index],
    });
    setOpenDisciplineWithLesson(true);
  };

  const handleCloseDisciplineModal = () => {
    setOpenDisciplineWithLesson(false);
    setEditingDiscipline(null);
  };

  return {
    open,
    setOpen,
    openDisciplineWithLesson,
    setOpenDisciplineWithLesson,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    selectedGiftId,
    setSelectedGiftId,
    editingDiscipline,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleEditDiscipline,
    handleCloseDisciplineModal,
  };
}
